module.exports = __webpack_public_path__ + "static/media/add_worker.1eda635a.svg";